module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Távoli nyitás")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "element_type_id",
      "label": "Típus",
      "name": "element_type_id",
      "options": _vm.element_types
    },
    on: {
      "input": _vm.getElements
    },
    model: {
      value: (_vm.element_type_id),
      callback: function($$v) {
        _vm.element_type_id = $$v
      },
      expression: "element_type_id"
    }
  })], 1)]), _vm._v(" "), (_vm.elements.length > 0) ? _c('TabulatorTable', {
    attrs: {
      "options": _vm.tabulator_opts
    },
    model: {
      value: (_vm.elements),
      callback: function($$v) {
        _vm.elements = $$v
      },
      expression: "elements"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), (_vm.barrier_id != false) ? _c('cameraViewPopup', {
    attrs: {
      "opening": _vm.opening,
      "permanentOpening": _vm.permanentOpening,
      "normalOperationDatetime": _vm.normalOperationDatetime,
      "normalOperationNow": _vm.normalOperationNow,
      "barrier_id": _vm.barrier_id
    },
    on: {
      "close": function($event) {
        _vm.barrier_id = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.normal_mode_popup_element_id != false) ? _c('normalModePopup', {
    attrs: {
      "normal_mode_popup_element_id": _vm.normal_mode_popup_element_id
    },
    on: {
      "save": function($event) {
        _vm.normal_mode_popup_element_id = false;
        _vm.getElements();
      },
      "close": function($event) {
        _vm.normal_mode_popup_element_id = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aec87cf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/remote_open.vue
// module id = 323
// module chunks = 0